var auto_renewal_toggle = (function ($) {

    var $wrapper;
    var $toggle;

    var last_notice_timeout;
    var current_status;
    var original_status;

    var _init = function () {
        _init_auto_renewal_toggle();
    };

    var _init_auto_renewal_toggle = function () {
        $wrapper = $('#member-area-toggle-auto-renewal-wrapper');

        if ($wrapper.length > 0) {
            $toggle = $wrapper.find('.toggle');

            var $checkbox = $toggle.siblings('#auto-renewal-toggle');

            original_status = $checkbox.prop('checked');
            current_status = original_status;

            $toggle.on('click', function () {
                _toggle_auto_renewal();
            });

            var $save_button = $('#save-auto-renewal');

            if ($save_button.length > 0) {
                $save_button.on('click', _save)
            }
        }
    }

    var _toggle_auto_renewal = function () {
        if ($wrapper.hasClass('loading')) {
            return;
        }

        var $checkbox = $toggle.siblings('#auto-renewal-toggle');
        var toggling_to = !$checkbox.prop('checked');

        $checkbox.prop('checked', toggling_to);
        $wrapper.find('.toggle-label').text(toggling_to ? 'ON' : 'OFF');

        current_status = toggling_to;

        _maybe_disable_button();
    };

    var _save = function (e) {
        e.preventDefault();

        if ($wrapper.hasClass('loading') || $wrapper.find('#save-auto-renewal').hasClass('disabled')) {
            return;
        }

        $wrapper.addClass('loading');

        const data = {
            nonce: scriptData.vibe_eos_toggleAutoRenewal_ajax_toggle_nonce,
            action: 'vibe_eos_toggleAutoRenewal_ajax_toggle',
            should_enable: $wrapper.find('#auto-renewal-toggle').prop('checked') ? 1 : 0,
        }

        $.post(scriptData.ajaxURL, data, res => _toggle_auto_renewal_response(res, $wrapper));
    }

    var _toggle_auto_renewal_response = function (res, $wrapper) {
        $wrapper.removeClass('loading');

        var $notice = $wrapper.find('.notice');

        if (res.success) {
            // TODO: Remove this if we end up not keeping it
            // $wrapper.find('#auto-renewal-enabled-status').text(res.new_value ? 'Enabled' : 'Disabled');

            $notice.text('Saved').removeClass('failed');
            original_status = current_status;
        } else {
            console.log('Error: ' + res.message);
            $notice.text('Error').addClass('failed');
        }

        _show_notice();
        _maybe_disable_button();
    };

    var _show_notice = function () {
        var $notice = $wrapper.find('.notice');

        $notice.removeClass('hidden');

        if (last_notice_timeout) {
            clearTimeout(last_notice_timeout);
        }

        last_notice_timeout = setTimeout(_hide_notice, 4000);
    }

    var _hide_notice = function () {
        $wrapper.find('.notice').addClass('hidden');
    }

    var _maybe_disable_button = function () {
        if (current_status === original_status) {
            $wrapper.find('#save-auto-renewal').addClass('disabled');
        } else {
            $wrapper.find('#save-auto-renewal').removeClass('disabled');
        }
    }

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = auto_renewal_toggle;